import { z } from 'zod'

// Направленная зависимость: taskId «ждёт» dependsOnId (обратная сторона —
// dependsOnId «блокирует» taskId).
export const DependencySchema = z.object({
  taskId: z.string(),
  dependsOnId: z.string(),
})
export type Dependency = z.infer<typeof DependencySchema>

// Узел gantt-проекции доски: минимум для отрисовки связей + флаги риска
// (blocked — есть незакрытая зависимость, waiting — в waiting-колонке).
export const GanttTaskSchema = z.object({
  id: z.string(),
  title: z.string(),
  dueDate: z.string().nullable(),
  columnId: z.string(),
  assigneeId: z.string().nullable(),
  blocked: z.boolean(),
  waiting: z.boolean(),
})
export type GanttTask = z.infer<typeof GanttTaskSchema>

export const GanttSchema = z.object({
  boardId: z.string(),
  tasks: z.array(GanttTaskSchema),
  dependencies: z.array(DependencySchema),
})
export type Gantt = z.infer<typeof GanttSchema>

// Симметричная связь «Связано» (другая сторона нормализованной пары).
export const LinkedTaskSchema = z.object({
  id: z.string(),
  title: z.string(),
  boardId: z.string(),
})
export type LinkedTask = z.infer<typeof LinkedTaskSchema>

// Контрагент зависимости (blocker/dependent). done — закрыт ли контрагент; cross-
// board включён (boardId несёт свою доску, ссылка ведёт по id).
export const DependencyTaskSchema = z.object({
  id: z.string(),
  title: z.string(),
  boardId: z.string(),
  done: z.boolean(),
})
export type DependencyTask = z.infer<typeof DependencyTaskSchema>

// GET /tasks/{id}/dependencies — надёжный источник «Ждёт»/«Блокирует»: blockers —
// от кого задача зависит (ждёт), dependents — кто зависит от неё (она блокирует).
export const TaskDependenciesSchema = z.object({
  blockers: z.array(DependencyTaskSchema),
  dependents: z.array(DependencyTaskSchema),
})
export type TaskDependencies = z.infer<typeof TaskDependenciesSchema>

// Тип найденной сущности (00-architecture § 6). message-хит — совпадение в треде
// задачи (entity_id = id задачи), но своим kind, чтобы иконка/навигация отличались.
export const SearchHitKindSchema = z.enum(['task', 'message', 'company', 'project', 'board'])
export type SearchHitKind = z.infer<typeof SearchHitKindSchema>

// Канонический HitView: kind + entity_id (id) + label (title) + url (deep-link) +
// matched_in (title|description|thread|name|tag). Остальное — контекст хита (пусто
// у kind, к которому неприменимо): task_id для #ref, board/project/company — «где».
export const SearchHitSchema = z.object({
  kind: SearchHitKindSchema,
  id: z.string(),
  title: z.string(),
  snippet: z.string(),
  matchedIn: z.string(),
  url: z.string(),
  taskId: z.string().default(''),
  boardId: z.string().default(''),
  boardName: z.string().default(''),
  projectId: z.string().default(''),
  projectName: z.string().default(''),
  companyId: z.string().default(''),
  companyName: z.string().default(''),
})
export type SearchHit = z.infer<typeof SearchHitSchema>
